// extracted by mini-css-extract-plugin
export default {"wrapper":"privacynotice-module--wrapper--Xb8Q0","container":"privacynotice-module--container--ifkQC","content":"privacynotice-module--content--F8KDT"};